// Lightweight GA4 wrapper with safe no-ops when gtag is unavailable.

export function trackEvent(category, action, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', action, { event_category: category, ...params });
  }
}

export function trackPageview(pagePath) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', { page_path: pagePath });
  }
}

export function init() {
  // GA4 is initialized in public/index.html via the gtag snippet.
}
